import React from 'react';
import { useCountdown } from '../../hooks/useCountdown';
import { Countdown } from '../Countdown/Countdown';
import styles from './PassiveTimer.module.scss';

export function OmnigrowPassiveTimerDate() {
  const countdown = useCountdown(getPassiveTimerReset().getTime());

  return <Countdown countdown={countdown} concise />;
}

export function OmnigrowPassiveTimer() {
  return (
    <div className={styles.timerLayout}>
      <div className={styles.timerText}>
        <TimerIcon />
        <div className={styles.claimLabel}> Next Reward In</div>
      </div>
      <OmnigrowPassiveTimerDate />
    </div>
  );
}

const getPassiveTimerReset = (): Date => {
  const currentDate = new Date();
  const flipDay = currentDate.getUTCHours() >= 15 ? 1 : 0;
  currentDate.setDate(currentDate.getDate() + flipDay);
  currentDate.setUTCHours(15,0,0,0);
  return currentDate;
};

const TimerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_3041_49)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6565 4.34247C8.39926 4.0345 9.19544 3.87598 9.99951 3.87598C10.8036 3.87598 11.5998 4.0345 12.3425 4.34247C13.0853 4.65045 13.76 5.10184 14.3282 5.67082L14.3293 5.67198L15.7007 7.03927H13.7664C13.3522 7.03927 13.0164 7.37505 13.0164 7.78927C13.0164 8.20348 13.3522 8.53927 13.7664 8.53927H17.507C17.5171 8.53937 17.5272 8.53928 17.5373 8.53899C17.9418 8.52796 18.2664 8.19651 18.2664 7.78927V4.03927C18.2664 3.62505 17.9307 3.28927 17.5164 3.28927C17.1022 3.28927 16.7664 3.62505 16.7664 4.03927V5.98371L15.3896 4.61093L15.389 4.61029C14.6816 3.90209 13.8417 3.34024 12.917 2.95686C11.9922 2.57337 11.0007 2.37598 9.99951 2.37598C8.99827 2.37598 8.00686 2.57337 7.08197 2.95686C6.15709 3.34036 5.31689 3.90243 4.60942 4.61093C4.31674 4.90404 4.31709 5.37891 4.61019 5.67159C4.9033 5.96427 5.37817 5.96392 5.67085 5.67082C6.239 5.10184 6.91375 4.65045 7.6565 4.34247ZM2.19664 11.518C2.28386 11.4818 2.37939 11.4616 2.47957 11.4611C2.48101 11.4611 2.48245 11.4611 2.48389 11.4611H2.48447H6.23389C6.6481 11.4611 6.98389 11.7968 6.98389 12.2111C6.98389 12.6253 6.6481 12.9611 6.23389 12.9611H4.29833L5.66969 14.3284L5.67086 14.3296C6.239 14.8985 6.91375 15.3499 7.6565 15.6579C8.39926 15.9659 9.19544 16.1244 9.99951 16.1244C10.8036 16.1244 11.5998 15.9659 12.3425 15.6579C13.0853 15.3499 13.76 14.8985 14.3282 14.3296C14.6208 14.0364 15.0957 14.0361 15.3888 14.3288C15.6819 14.6215 15.6823 15.0963 15.3896 15.3894C14.6821 16.0979 13.8419 16.66 12.917 17.0435C11.9922 17.427 11.0007 17.6244 9.99951 17.6244C8.99827 17.6244 8.00686 17.427 7.08197 17.0435C6.15734 16.6601 5.31734 16.0982 4.61 15.39L4.60942 15.3894L3.23389 14.018V15.9611C3.23389 16.3753 2.8981 16.7111 2.48389 16.7111C2.06967 16.7111 1.73389 16.3753 1.73389 15.9611V12.2111C1.73389 11.8986 1.92496 11.6308 2.19664 11.518Z"
        fill="white"
        fillOpacity="0.6"
      />
    </g>
    <defs>
      <clipPath id="clip0_3041_49">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
